import { render, staticRenderFns } from "./ChargebackUserInfo.vue?vue&type=template&id=20ec5e72"
import script from "./ChargebackUserInfo.vue?vue&type=script&lang=js"
export * from "./ChargebackUserInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports